import { render, staticRenderFns } from "./MemberOrderDetail.vue?vue&type=template&id=2aa5bd24&scoped=true&"
import script from "./MemberOrderDetail.vue?vue&type=script&lang=js&"
export * from "./MemberOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./MemberOrderDetail.vue?vue&type=style&index=0&id=2aa5bd24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa5bd24",
  null
  
)

export default component.exports